import styles from "./FilterTile.module.css";
import classNames from "classnames";
import { useFilterSidebar } from "../../Pregrine/FilterSidebar/useFilterSidebar";
import { useState } from "react";

const FilterTile = (props) => {
  const {
    filtersListing,
    setFilters,
    filters,
    setSelectedFilters,
    selectedFilters,
    initialFilter,
    searchInput,
    categoryId,
  } = props;

  const talonProps = useFilterSidebar({
    setFilters,
    filtersListing,
    filters,
    setSelectedFilters,
    selectedFilters,
    initialFilter,
    searchInput,
    categoryId,
  });

  const { handleCheckboxChange, ConfigData } = talonProps;

  const [filtersLimit, setFiltersLimit] = useState(4);

  const newFilterCategoryIds =
    ConfigData?.new_filter_catogory?.split(",").map((id) => Number(id)) || [];
  return (
    <div
      className={classNames(
        "d-flex justify-content-between align-items-start",
        !newFilterCategoryIds?.includes(categoryId)
          ? styles.filterTilemain
          : styles.filterTilemainSpecific
      )}
    >
      <div className={styles.catgory}>
        <h2 className={styles.title}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1rem"
            height="1rem"
            viewBox="0 0 24 24"
          >
            <path
              fill="#111111"
              d="M14 12v7.88c.04.3-.06.62-.29.83a.996.996 0 0 1-1.41 0l-2.01-2.01a.989.989 0 0 1-.29-.83V12h-.03L4.21 4.62a1 1 0 0 1 .17-1.4c.19-.14.4-.22.62-.22h14c.22 0 .43.08.62.22a1 1 0 0 1 .17 1.4L14.03 12z"
            />
          </svg>
          Find by:
        </h2>
        <div
          className={classNames({
            [styles.filter_feature]: newFilterCategoryIds?.includes(categoryId),
          })}
        >
          <ul
            className={classNames(styles.filt, {
              [styles.showMoreOpen]: filtersLimit > 4,
              [styles.showMoreClosed]: filtersLimit === 4,
            })}
            id="navMenus"
          >
            {!newFilterCategoryIds?.includes(categoryId)
              ? filtersListing &&
                filtersListing.length > 0 &&
                filtersListing
                  .filter((op) => op.attribute_code !== "category_uid")
                  .slice(0, filtersLimit)
                  .map((item, idx) => (
                    <div className="dropdown" key={idx}>
                      <button
                        className="dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {item.label.length > 17
                          ? item.label.slice(0, 18) + "..."
                          : item.label}
                      </button>
                      <ul
                        className={classNames(
                          "dropdown-menu",
                          styles.dropContainer
                        )}
                        aria-labelledby="dropdownMenuButton1"
                      >
                        {item.options
                          .filter(
                            (op) =>
                              op.label.toLowerCase() !== "n/a" &&
                              op.label.toLowerCase() !== "na"
                          )
                          .map((option, index) => (
                            <li key={index} className={styles.optionItem}>
                              <input
                                type="checkbox"
                                name={item.attribute_code}
                                id={`checkbox${item.label}${option.label}`}
                                checked={selectedFilters.some(
                                  (filter) =>
                                    filter.label === option.label &&
                                    filter.value === option.value
                                )}
                                onChange={() =>
                                  handleCheckboxChange(item, option)
                                }
                                className={classNames({
                                  [styles.customRadio]:
                                    item.attribute_code === "price",
                                })}
                              />
                              <label
                                htmlFor={`checkbox${item.label}${option.label}`}
                                className={styles.checkLabel}
                              >
                                {option.label.split("-")[0] === "0"
                                  ? `Upto ${option.label.split("-")[1]}`
                                  : option.label}
                              </label>
                            </li>
                          ))}
                      </ul>
                    </div>
                  ))
              : filtersListing &&
                filtersListing.length > 0 &&
                filtersListing
                  .filter((op) => op.attribute_code !== "category_uid")
                  .slice(0, filtersLimit)
                  .map((item, idx) => {
                    if (item.attribute_code === "price") {
                      return (
                        <div className="dropdown" key={idx}>
                          <button
                            className="dropdown-toggle"
                            type="button"
                            id={`dropdownMenuButton${idx}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {item.label.length > 17
                              ? item.label.slice(0, 18) + "..."
                              : item.label}
                          </button>
                          <ul
                            className={classNames(
                              "dropdown-menu",
                              styles.dropContainer
                            )}
                            aria-labelledby={`dropdownMenuButton${idx}`}
                          >
                            {item.options
                              .filter(
                                (op) =>
                                  op.label.toLowerCase() !== "n/a" &&
                                  op.label.toLowerCase() !== "na"
                              )
                              .map((option, index) => (
                                <li key={index} className={styles.optionItem}>
                                  <input
                                    type="checkbox"
                                    name={item.attribute_code}
                                    id={`checkbox${item.label}${option.label}`}
                                    checked={selectedFilters.some(
                                      (filter) =>
                                        filter.label === option.label &&
                                        filter.value === option.value
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(item, option)
                                    }
                                    className={classNames({
                                      [styles.customRadio]:
                                        item.attribute_code === "price",
                                    })}
                                  />
                                  <label
                                    htmlFor={`checkbox${item.label}${option.label}`}
                                    className={styles.checkLabel}
                                  >
                                    {option.label.split("-")[0] === "0"
                                      ? `Upto ${option.label.split("-")[1]}`
                                      : option.label}
                                  </label>
                                </li>
                              ))}
                          </ul>
                        </div>
                      );
                    }

                    return (
                      <>
                        <div
                          className={classNames(
                            styles.optionLabel,
                            "dropdown",
                            {
                              [styles.optionLabelSelected]:
                                Object.keys(filters).length === 1,
                            }
                          )}
                          onClick={() => setSelectedFilters([])}
                        >
                          All Offers
                        </div>
                        {item.options
                          .filter(
                            (op) =>
                              op.label.toLowerCase() !== "n/a" &&
                              op.label.toLowerCase() !== "na"
                          )
                          .map((option) => {
                            const isSelected = selectedFilters.some(
                              (filter) =>
                                filter.value == option.value &&
                                filter.label.toLowerCase() ===
                                  option.label.toLowerCase()
                            );

                            return (
                              <div
                                key={option.value}
                                onClick={() =>
                                  handleCheckboxChange(item, option)
                                }
                                className={classNames(
                                  styles.optionLabel,
                                  "dropdown",
                                  {
                                    [styles.optionLabelSelected]: isSelected,
                                  }
                                )}
                              >
                                {option.label}
                              </div>
                            );
                          })}
                      </>
                    );
                  })}

            {filtersListing &&
            filtersListing.length > 0 &&
            filtersListing.filter((op) => op.attribute_code !== "category_uid")
              .length > 4 ? (
              <button
                className={styles.showMoreBtn}
                onClick={() => {
                  if (filtersLimit === 4) {
                    setFiltersLimit(filtersListing.length);
                  } else {
                    setFiltersLimit(4);
                  }
                }}
              >
                {filtersLimit === 4 ? "View All" : "View Less"}
              </button>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FilterTile;
